export default __webpack_public_path__ + "static/media/Emerald@3x.d3e69c3e.png";